export default "__VITE_ASSET__CtJPiMXg__"